/* eslint-disable max-len */
require.ensure(['scrollmagic-core', 'scrollmagic-gsap'], () => {
  const ScrollMagic = require('scrollmagic-core');
  require('scrollmagic-gsap');

  // scroll magic on One Plus page

  // init controller
  const section = new ScrollMagic.Controller();

  if ($('.js-section-2').length) {
    new ScrollMagic.Scene({ triggerElement: '.js-section-2' })
      .setClassToggle('.js-section-2', 'is-in-view')
      .addTo(section);

    // show the sitcky nav once the second section is in view
    if ($('.js-sticky-nav').length) {
      new ScrollMagic.Scene({ triggerElement: '.js-section-2' })
        .setClassToggle('.js-sticky-nav', 'is-active')
        .addTo(section);
    }
  }

  if ($('.js-technologies').length) {
    if ($('.js-section-2').length && $('.js-sticky-nav').length) {
      new ScrollMagic.Scene({ triggerElement: '.js-technologies', offset: 800 })
        .setClassToggle('.js-sticky-nav', 'is-unactive')
        .addTo(section);
    }
  }

  if ($('.js-section-3').length) {
    new ScrollMagic.Scene({ triggerElement: '.js-section-3', offset: 325 })
      .setClassToggle('.js-section-3', 'is-in-view')
      .addTo(section);
  }

  if ($('.js-section-4').length) {
    new ScrollMagic.Scene({ triggerElement: '.js-section-4', offset: 300 })
      .setClassToggle('.js-section-4', 'is-in-view')
      .addTo(section);
  }

  if (window.matchMedia('(max-width: 767px)').matches) {
    // Mobile scroll
    $(window).on('scroll', () => {
      // Battery tab is opened...
      if ($('.js-section-toggle').is(':visible')) {
        // current position from top
        const pageTop = $(window).scrollTop();

        // height of the sticky row
        const stickyHeight = $('.prod-table .fixed').height() + $('.mob-table-nav').height();

        // start of the best table, which will start the sticky row
        const stickyTop = $('.best-table').offset().top - $('.mob-table-nav').height();

        // end of the best table, which will stop the sticky row
        const stickyBottom = ($('.best-table').offset().top + $('.best-table').height()) - stickyHeight;

        if (pageTop >= stickyTop) {
          // check to see if we've gone past the table
          if (pageTop >= stickyBottom) {
            $('.mob-table-nav').css({ position: 'relative', top: '0' });
            $('.prod-table .fixed, .key .fixed').css({ position: 'relative', top: '0' });
            $('.prod-table, .key').css('margin-top', 0);
          } else {
            $('.mob-table-nav').css({ position: 'fixed', top: '0' });
            $('.mob-table-nav').css({ width: '100%' });
            $('.prod-table .fixed, .key .fixed').css({ position: 'fixed', top: $('.mob-table-nav').height() });
            $('.prod-table, .key').css('margin-top', stickyHeight);
            $('.prod-table .fixed').width($('.prod-table .table-row-2').width());
            $('.key .fixed').width($('.key .table-row-2').width());
          }
        } else {
          $('.mob-table-nav').css({ position: 'relative', top: '0' });
          $('.prod-table .fixed, .key .fixed').css({ position: 'relative', top: '0' });
          $('.prod-table, .key').css('margin-top', 0);
        }
      }
    });
  } else {
    // Tablet/desktop scroll
    $(window).on('scroll', () => {
      // Battery tab is opened...
      if ($('.js-section-toggle').is(':visible')) {
        // calculate the header padding.
        let menuPadding = $('.header-drop').height();
        if (window.matchMedia('(max-width: 991px)').matches) {
          menuPadding = 0;
        }

        // current position from top (inc any header padding).
        const pageTop = $(window).scrollTop() + menuPadding;

        // height of the sticky row
        const stickyHeight = $('.prod-table .fixed').height();

        // start of the best table, which will start the sticky row
        const stickyTop = $('.best-table').offset().top + menuPadding;

        // end of the best table, which will stop the sticky row
        const stickyBottom = ($('.best-table').offset().top + $('.best-table').height()) - stickyHeight;

        if (pageTop >= stickyTop) {
          // check to see if we've gone past the table
          if (pageTop >= stickyBottom) {
            $('.prod-table .fixed, .key .fixed').css({ position: 'relative', top: '0' });
            $('.prod-table, .key').css('margin-top', 0);
          } else {
            $('.prod-table .fixed, .key .fixed').css({ position: 'fixed', top: menuPadding });
            $('.prod-table, .key').css('margin-top', stickyHeight);
            $('.prod-table .fixed').width($('.prod-table .table-row-2').width());
            $('.key .fixed').width($('.key .table-row-2').width());
          }
        } else {
          $('.prod-table .fixed, .key .fixed').css({ position: 'relative', top: '0' });
          $('.prod-table, .key').css('margin-top', 0);
        }
      }
    });
  }

  // NEW 36v scroll scripts
  if ($('.js-fade-in-componant').length) {
    if (window.matchMedia('(min-width: 320px)').matches) {
      new ScrollMagic.Scene({ triggerElement: '.js-fade-in-componant-1', duration: 500, triggerHook: 'onLeave' })
          .setPin('.js-fade-in-componant-1')
          .addTo(section);
    }

    if ($('.js-fade-in-componant-bg-screen-1').length) {
      const tweenBg = TweenMax.to('.js-fade-in-componant-bg-screen-1', 0.5, { css: { opacity: 0.5 } });

      if (window.matchMedia('(min-width: 320px)').matches) {
        new ScrollMagic.Scene({ triggerElement: '.js-fade-in-componant-1', duration: 200, triggerHook: 'onLeave' })
          .setTween(tweenBg)
          .addTo(section);
      }
    }

    if ($('.js-fade-in-componant-content-1').length) {
      const tweenScroll = TweenMax.to('.js-fade-in-componant-content-1', 0.5, { css: { top: 0, opacity: 1 } });

      if (window.matchMedia('(min-width: 320px)').matches) {
        new ScrollMagic.Scene({ triggerElement: '.js-fade-in-componant-1', duration: 500, triggerHook: 'onLeave' })
          .setTween(tweenScroll)
          .addTo(section);
      }
    }

    if (window.matchMedia('(min-width: 320px)').matches) {
      new ScrollMagic.Scene({ triggerElement: '.js-fade-in-componant-2', duration: 500, triggerHook: 'onLeave' })
        .setPin('.js-fade-in-componant-2')
        .addTo(section);
    }

    if ($('.js-fade-in-componant-bg-screen-2').length) {
      const tweenBg2 = TweenMax.to('.js-fade-in-componant-bg-screen-2', 0.5, { css: { opacity: 0.5 } });

      if (window.matchMedia('(min-width: 320px)').matches) {
        new ScrollMagic.Scene({ triggerElement: '.js-fade-in-componant-2', duration: 200, triggerHook: 'onLeave' })
          .setTween(tweenBg2)
          .addTo(section);
      }
    }

    if ($('.js-fade-in-componant-content-2').length) {
      const tweenScroll2 = TweenMax.to('.js-fade-in-componant-content-2', 0.5, { css: { top: 0, opacity: 1 } });

      if (window.matchMedia('(min-width: 320px)').matches) {
        new ScrollMagic.Scene({ triggerElement: '.js-fade-in-componant-2', duration: 500, triggerHook: 'onLeave' })
          .setTween(tweenScroll2)
          .addTo(section);
      }
    }
  }

  if ($('.js-anim-section').length) {
    const tweenBat2 = TweenMax.to('.js-battery-anim-2', 0.5, { css: { top: -25 } });
    const tweenBat3 = TweenMax.to('.js-battery-anim-3', 0.5, { css: { top: -45 } });
    const tweenBat4 = TweenMax.to('.js-battery-anim-4', 0.5, { css: { top: -100, marginBottom: -100 } });
    const tweenBatOpacity = TweenMax.to('.section--battery-anim__left', 0.5, { css: { opacity: 1 } });

    // new ScrollMagic.Scene({ triggerElement: '.js-anim-section', duration: 500, triggerHook: 'onLeave' })
    //   .setPin('.js-anim-section')
    //   .addTo(section);

    new ScrollMagic.Scene({ triggerElement: '.js-anim-section', duration: 500 })
      .setTween(tweenBat2)
      .addTo(section);

    new ScrollMagic.Scene({ triggerElement: '.js-anim-section', duration: 500 })
      .setTween(tweenBat3)
      .addTo(section);

    new ScrollMagic.Scene({ triggerElement: '.js-anim-section', duration: 500 })
      .setTween(tweenBat4)
      .addTo(section);

    new ScrollMagic.Scene({ triggerElement: '.js-anim-section', duration: 500 })
      .setTween(tweenBatOpacity)
      .addTo(section);
  }

  const $graphArea = $('.js-section-graph');
  const graphAreaClass = '.js-section-graph';
  const graphBarClass = '.js-graph-bar';
  const graphImageClass = '.js-graph-image';
  const $graphCount = $('.js-graph-counter');
  const graphCountClass = '.js-graph-counter';
  const count = { score: 0 };
  let endCount = 90;

  if ($graphArea.length) {
    const $endCount = $graphArea.find('.js-graph-max');
    if ($endCount.length) {
      endCount = $endCount.val();
    }

    // if (window.matchMedia('(min-width: 1025px)').matches) {
    //   new ScrollMagic.Scene({ triggerElement: graphAreaClass, duration: 0 })
    //     .setPin(graphAreaClass)
    //     .addTo(section);
    // }

    if ($(graphBarClass).length) {
      const tweenBar = TweenMax.to(graphBarClass, 1, { css: { width: '80%' } });
      if (window.matchMedia('(min-width: 1025px)').matches) {
        new ScrollMagic.Scene({ triggerElement: graphAreaClass, duration: 0 })
          .setTween(tweenBar)
          .addTo(section);
      } else {
        new ScrollMagic.Scene({ triggerElement: graphAreaClass, duration: 0 })
          .setTween(tweenBar)
          .addTo(section);
      }
    }

    if ($(graphImageClass).length) {
      if (window.matchMedia('(min-width: 767px)').matches) {
        const tweenImage = TweenMax.to(graphImageClass, 1, { css: { left: '70%' } });
        if (window.matchMedia('(min-width: 1025px)').matches) {
          new ScrollMagic.Scene({ triggerElement: graphAreaClass, duration: 0 })
            .setTween(tweenImage)
            .addTo(section);
        } else {
          new ScrollMagic.Scene({ triggerElement: graphAreaClass, duration: 0 })
            .setTween(tweenImage)
            .addTo(section);
        }
      }
    }

    if ($(graphCountClass).length) {
      const tweenNumber = TweenMax.to(count, 1, { score: endCount, roundProps: 'score', onUpdate: updateHandler });

      if (window.matchMedia('(min-width: 1025px)').matches) {
        new ScrollMagic.Scene({ triggerElement: graphAreaClass, duration: 0 })
          .setTween(tweenNumber)
          .addTo(section);
      } else {
        new ScrollMagic.Scene({ triggerElement: graphAreaClass, duration: 0 })
          .setTween(tweenNumber)
          .addTo(section);
      }
    }
  }

  function updateHandler() {
    $graphCount.text(count.score);
  }
});
